module.exports = __webpack_public_path__ + "img/coin.e125b839.svg";